// Shared between useClientOrdersPage.js (Client Orders page) and
// useAdminDashboardPage.js (dashboard "Accept"/"Reject" quick actions) so
// the ETA presets and reject reasons never drift between the two entry
// points into the same accept/reject flow.

export const quickEta = (kind) => {
  const d = new Date();
  if (kind === 'tomorrowAm') { d.setDate(d.getDate() + 1); d.setHours(9, 0, 0, 0); }
  if (kind === 'in2days') { d.setDate(d.getDate() + 2); d.setHours(9, 0, 0, 0); }
  if (kind === 'nextMonday') {
    const day = d.getDay();
    const add = ((8 - day) % 7) || 7;
    d.setDate(d.getDate() + add);
    d.setHours(9, 0, 0, 0);
  }
  // toISOString then trim seconds for a datetime-local input value
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const getRejectPresets = (t) => [
  t('Out of stock', { defaultValue: 'Out of stock' }),
  t('Below minimum order', { defaultValue: 'Below minimum order' }),
  t('Outside delivery area', { defaultValue: 'Outside delivery area' }),
  t('Payment on account overdue', { defaultValue: 'Payment on account overdue' }),
];
